// Vendor
import * as React from 'react';

// Internal
import { ChartGenerations } from '@src/charts/ChartGenerations/ChartGenerations';
import { IconArrow } from '@src/svg/IconArrow';
import { IconCreditCard } from '@src/svg/IconCreditCard';
import { IconRecycle } from '@src/svg/IconRecycle';
import { DEFAULT_SAL_PROPS, SAL_DELAY } from '@src/config/sal';
import { SPOT_GREEN } from '@thredup/styleguide/src/variables/colors';

// Styles
import styles from './styles.module.css';

const GenZPower: React.FC = () => {
  return (
    <div className="tup-slide">
      <h1 {...DEFAULT_SAL_PROPS} className="max-w-xl">
        Gen Z is Powering the Growth of Secondhand Shopping
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-3 md:gap-20">
        <div className="col-span-2">
          <h2 {...DEFAULT_SAL_PROPS} data-sal-delay={SAL_DELAY * 1}>
            Young shoppers are adopting secondhand fashion faster than any other
            age group.
          </h2>
          <div style={{ height: 475 }}>
            <ChartGenerations />
          </div>
          <p
            {...DEFAULT_SAL_PROPS}
            data-sal="fade"
            data-sal-delay={SAL_DELAY * 3}
            className="tup-description max-w-lg"
          >
            Percent of each age group that bought secondhand apparel, footwear,
            or accessories<sup>2</sup>
          </p>
        </div>
        <div
          {...DEFAULT_SAL_PROPS}
          data-sal="fade"
          data-sal-delay={SAL_DELAY * 2}
          className="bg-brand-background text-center p-8 mt-8 md:mt-0"
        >
          <h2 className="mb-4">Gen Z Prioritizes Sustainability</h2>
          <IconRecycle className="m-auto" />
          <p className="p-4">
            <b>80%</b> say there’s no stigma to buying used fashion.
            <sup>2</sup>
          </p>
          <IconCreditCard className="m-auto mt-8" />
          <p className="p-4">
            <b>90%</b> of Gen Z shoppers have or are open to shopping secondhand
            when money gets tight.<sup>3</sup>
          </p>
          <p className="p-4 pb-2">
            Gen Z shares their
            <br />
            thoughts on thrifting.
          </p>
          <a
            className="uppercase ml-4 mt-0 text-sm flex font-bold text-green items-center justify-center"
            href="https://youtu.be/xwv-RFZqcZY"
            rel="noopener noreferrer"
            target="_blank"
          >
            Watch Now{' '}
            <IconArrow
              className={styles.arrow}
              direction="right"
              fill={SPOT_GREEN}
              height={20}
              width={30}
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export { GenZPower };
